import { Button } from '@artosera/ui';
import type { Langue } from '@artosera/shared';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { titrePeriode, type Jour, type VueCalendrier } from './periodes.js';
import styles from './Calendrier.module.css';

/**
 * La barre d'un calendrier : le sélecteur de vue, puis précédent /
 * aujourd'hui / suivant autour du titre de la période. `navigation: false`
 * (la liste des expositions, qui n'a pas de période) ne garde que le sélecteur.
 */
export function BarreCalendrier({
  vue,
  vues,
  ancre,
  langue,
  navigation = true,
  onVue,
  onDeplacer,
}: {
  vue: VueCalendrier;
  vues: readonly VueCalendrier[];
  ancre: Jour;
  langue: Langue;
  navigation?: boolean;
  onVue: (vue: VueCalendrier) => void;
  /** -1 précédent, 1 suivant, 0 aujourd'hui. */
  onDeplacer: (sens: -1 | 0 | 1) => void;
}): JSX.Element {
  const { t } = useTranslation('regie');
  return (
    <div className={styles.barre} data-ui="calendrier-barre">
      <div className={styles.segments} role="group" aria-label={t('calendrier.affichage')}>
        {vues.map((code) => (
          <button
            key={code}
            type="button"
            className={styles.segment}
            aria-pressed={code === vue}
            onClick={() => onVue(code)}
          >
            {t(`calendrier.vues.${code}`)}
          </button>
        ))}
      </div>
      {navigation ? (
        <div className={styles.navigation}>
          <Button variant="secondary" size="sm" onClick={() => onDeplacer(-1)}>
            {t(`calendrier.precedent.${vue}`)}
          </Button>
          <Button variant="ghost" size="sm" onClick={() => onDeplacer(0)}>
            {t('calendrier.aujourdhui')}
          </Button>
          <Button variant="secondary" size="sm" onClick={() => onDeplacer(1)}>
            {t(`calendrier.suivant.${vue}`)}
          </Button>
          <h2 className={styles.titrePeriode}>{titrePeriode(vue, ancre, langue)}</h2>
        </div>
      ) : null}
    </div>
  );
}
